import { render, staticRenderFns } from "./WebSMenu.vue?vue&type=template&id=512fc3c0"
import script from "./WebSMenu.vue?vue&type=script&lang=js"
export * from "./WebSMenu.vue?vue&type=script&lang=js"
import style0 from "./WebSMenu.vue?vue&type=style&index=0&id=512fc3c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports